import { makeStyles } from '@material-ui/styles'

export default makeStyles(({ palette }) => ({
  tooltipIcon: {
    fontSize: '1.6rem',
    fill: palette.gray[64],
    stroke: palette.gray[64],
    cursor: 'help',
  },
  tooltipText: {
    fontSize: '1.4rem',
    color: 'white',
    textAlign: 'right',
  },
}))
